(function initVipOfferRenderer() {
    function renderVipOffer({ dn, imageUrl } = {}) {
        if (window.alreadySetupVipOffer) {
            return;
        }

        window.alreadySetupVipOffer = true;

        const productImgTag = document.querySelector('.candyrack-ppp-checkbox-layout__image');
        productImgTag.style = 'align-self: start;';
        productImgTag.children[0].children[0].src =
            'https://thepawprint.store/cdn/shop/files/200w-2.gif?v=1742599898&width=200';

        const productSelectorTag = document.querySelector('.candyrack-ppp-checkbox-layout__offer--checkbox');
        productSelectorTag.style = 'align-self: start; padding-top: 13px;';

        // const productTitleTag = document.querySelector(".candyrack-ppp-checkbox-layout__info--product-name");
        // productTitleTag.innerHTML = "Upgrade to a VIP Kit!";

        productImgTag.parentNode.insertBefore(productImgTag, productSelectorTag);

        const descriptionPTag = document.querySelector('.candyrack-ppp-checkbox-layout__info--offer-description');
        console.log(descriptionPTag);

        descriptionPTag.innerHTML =
            'Includes a Puzzle and 40oz Travel Mug featuring ' +
            dn +
            ' as well as a Premium Calendar Wall Mount and 108 Sticker Pack!';

        const candyRackDiv = document.querySelector('.candyrack-ppp-checkbox-layout__info');

        const freeShippingPTag = document.createElement('p');
        freeShippingPTag.innerHTML = '+ FREE Shipping';
        freeShippingPTag.classList.add('vip-free-shipping');

        candyRackDiv.insertBefore(freeShippingPTag, candyRackDiv.children[1]);

        const imgsDiv = document.createElement('div');
        imgsDiv.classList.add('vip-offer-img-container');
        candyRackDiv.appendChild(imgsDiv);

        const imageUrls = [
            'https://res.cloudinary.com/da9yd4bgx/image/fetch/t_puzzle-v1/' + encodeURIComponent(imageUrl),
            'https://thepawprint.store/cdn/shop/files/How_To_Place_Your_order_7.png?v=1739817362&width=300',
            'https://thepawprint.store/cdn/shop/files/calendar-mount-mockup-2.png?v=1719687581&width=300',
            'https://thepawprint.store/cdn/shop/files/stickers_21ff2509-1aa2-404e-9369-0168e1521614.png?v=1742597546&width=300',
        ];

        imageUrls.forEach((url) => {
            const imgTag = document.createElement('img');
            imgTag.src = url;
            imgsDiv.appendChild(imgTag);
        });

        const vipOfferAnchor = candyRackDiv.querySelector('a');
        vipOfferAnchor.style.pointerEvents = 'none';
        vipOfferAnchor.style.cursor = 'default';
        vipOfferAnchor.onclick = () => document.querySelector('.candyrack-ppp--checkbox > input').click();

        candyRackDiv.querySelector('div:first-child').onclick = () =>
            document.querySelector('.candyrack-ppp--checkbox > input').click();
    }

    window.renderVipOffer = renderVipOffer;
})();
